
<template>
  <el-dialog
    top="5vh"
    :visible.sync="dialogVisible"
    width="1250px"
    center
    @opened="getDetail"
    @close="close"
  >
    <!-- 详情 -->
    <ApplySample
      ref="sampleDialog"
      :isDisabled="true"
      :isDemandBrand="true"
      :isInput="false"
      :listData="listData"
    />

    <div v-loading="loading" class="operate-log">
      <!-- 操作日志 -->
      <div v-for="(item, index) in operateLogList" :key="index">
        <div class="form-item">
          <h3>{{item.operateType}}</h3>
          <el-form inline label-width="154px" label-position="left">
            <el-form-item label="操作时间：">
              <span>{{ item.createDate | dateFilter }}</span>
            </el-form-item>
            <el-form-item label="操作者：">
              <span>{{ item.createByName }}</span>
            </el-form-item>
            <el-form-item label="审核结果：" v-if="item.afterJson.checkStatus">
              <span>{{ item.afterJson.checkStatus === 'PASS' ? '通过' : '不通过' }}</span>
            </el-form-item>
            <el-form-item label="要求到样时间：" v-if="item.afterJson.checkStatus === 'PASS'">
              <span>{{ item.afterJson.askArrivalTime | dateFilter }}</span>
            </el-form-item>
            <el-form-item label="给供应商留言：" v-if="item.afterJson.checkStatus === 'PASS'">
              <span>{{ item.afterJson.forSupplierRemark }}</span>
            </el-form-item>
            <el-form-item label="理由：" v-if="item.afterJson.checkRemark">
              <span>{{ item.afterJson.checkRemark }}</span>
            </el-form-item>
            <el-form-item label="寄出时间：" v-if="item.afterJson.deliveryDate">
              <span>{{ item.afterJson.deliveryDate | dateFilter }}</span>
            </el-form-item>
            <el-form-item label="快递单号：" v-if="item.afterJson.expressNo">
              <span>{{ item.afterJson.expressNo }}</span>
            </el-form-item>
            <el-form-item label="快递公司：" v-if="item.afterJson.express">
              <span>{{ item.afterJson.express }}</span>
            </el-form-item>
            <el-form-item label="采用结果：" v-if="item.afterJson.isUse">
              <span>{{ item.afterJson.isUse === 'YES' ? '采用' : '不采用' }}</span>
            </el-form-item>
            <el-form-item label="理由：" v-if="item.afterJson.isUse === 'NO'">
              <span>{{ item.afterJson.reason }}</span>
            </el-form-item>
            <el-form-item label="样品是否可稳定供应：" v-if="item.afterJson.stableSupplyFlag">
              <span>{{ item.afterJson.stableSupplyFlag === 'YES' ? '是' : '否'}}</span>
            </el-form-item>
            <el-form-item label="回复到样时间：" v-if="item.afterJson.actualArrivalTime">
              <span>{{ item.afterJson.actualArrivalTime | dateFilter }}</span>
            </el-form-item>
            <el-form-item label="原因说明：" v-if="item.afterJson.stableSupplyReason">
              <span>{{ item.afterJson.stableSupplyReason }}</span>
            </el-form-item>
            <el-form-item label="备注：" v-if="item.afterJson.supplierRemark">
              <span>{{ item.afterJson.supplierRemark }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ApplySample from '@/components/ApplySample';
export default {
  components: { ApplySample },
  props: {
    listData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    dialogVisible: false,
    loading: false,
    operateLogList: [],
  }),
  mounted() {},
  methods: {
    getDetail() {
      // 外部用户不显示操作日志
      if(this.$store.getters.userSupplier.customerId === '1') {
        return;
      }
      this.loading = true;
      this.$http.sample
        .bizChangeLog({
          data: {
            bizId: this.listData.list[0].id,
          },
          pageNo: 1,
          pageSize: 100,
        })
        .then(result => {
          this.operateLogList = result.data.list.map(item => {
            item.afterJson = JSON.parse(item.afterJson);
            return item;
          });
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.operateLogList = [];
    }
  },
};
</script>
<style lang="less" scoped>
.operate-log {
  min-height: 200px;
  max-height: 500px;
  overflow: auto;
  background: #f7f7f7;
}
.form-item {
  border-bottom: 1px dashed #ccc;
  padding: 0 10px;
  h3 {
    float: left;
    margin-top: 3px;
    font-size: 14px;
  }
  form {
    margin: 5px 0 5px 165px;
    .el-form-item {
      margin-right: 50px;
      margin-bottom: 0px;
      width: 39%;
    }
  }
}
</style>